import { LinkOffRounded, LinkRounded } from "@mui/icons-material"

export const AVAILABLE_LABEL = (available) => (available ? "Disponible" : "Indisponible")
export const AVAILABLE_COLOR = (available) => (available ? "primary" : "error")
export const AVAILABLE_ICON = (available) =>
  available ? <LinkRounded color={AVAILABLE_COLOR(true)} /> : <LinkOffRounded color={AVAILABLE_COLOR(false)} />

export const CONSENT_FIELDS = ["diet", "media_consent", "risks_consent", "transportation", "unil_survey"]
